// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/toyotadisplay_rg.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/toyotadisplay_bd.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "T1 Body Font";
  src: local("T1 Body Font"), local("T1 Body Font"), url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
  /* IE6-IE8 */
}

@font-face {
  font-family: "toyotadisplay_bd";
  src: local("toyotadisplay_bd"), local("toyotadisplay_bd"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  /* IE6-IE8 */
}

body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-family: "T1 Body Font", Arial, Helvetica, sans-serif !important;
  font-size: 12px !important;
}

.loader {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: inline-block;
  border-top: 4px solid #efefef;
  border-right: 4px solid transparent;
  box-sizing: border-box;
  animation: rotation 1s linear infinite;
}

.loader::after {
  content: '';
  box-sizing: border-box;
  position: absolute;
  left: 0;
  top: 0;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  border-bottom: 4px solid #cf0000;
  border-left: 4px solid transparent;
}

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.button-dark-red-on-hover:hover {
  color: #a60622 !important;
}

.p-calendar {
  position: relative;
  display: inline-flex;
  /* max-width: 100%; */
  width: -webkit-fill-available;
}

td:has(> div.arrivedBackground) {
  background-color: #1c9b1d !important;
  color: white !important;
}

td:has(> div.inboundBackground) {
  background-color: hsla(36, 69%, 50%, 0.767) !important;
  color: white !important;
}

td:has(> div.pendingBackground) {
  background-color: hsla(0, 0%, 100%, 0) !important;
  color: black !important;
}

td:has(div.lcpBackground) {
  background-color: #1c9b1d !important;
  color: white !important;
}

td:has(div.instockBackground) {
  background-color: hsla(36, 69%, 50%, 0.767) !important;
  color: white !important;
}

/* .p-datatable-scrollable>.p-datatable-wrapper {
  position: relative;
  overflow: auto;
  height: 370px;
  border: 1px solid #dee2e6;
} */

.p-toast {
  width: calc(100% - var(--toast-indent, 0px));
  max-width: 20rem;
}

#compound-Manager-Table .p-datatable-scrollable>.p-datatable-wrapper {
  position: relative;
  overflow: auto;
  height: 37rem;
  max-height: 35rem !important;
  border: 1px solid #dee2e6;
}

#user-Manager-Table .p-datatable-scrollable>.p-datatable-wrapper {
  position: relative;
  overflow: auto;
  height: 37rem;
  max-height: 35rem !important;
  border: 1px solid #dee2e6;
}

#user-Manager-Table-access .p-datatable-scrollable>.p-datatable-wrapper {
  position: relative;
  overflow: auto;
  height: 10rem;
  max-height: 10rem !important;
  border: 1px solid #dee2e6;
}

#hub-Master-Table .p-datatable-scrollable>.p-datatable-wrapper {
  position: relative;
  overflow: auto;
  height: 37rem;
  max-height: 35rem !important;
  border: 1px solid #dee2e6;
}

.red-line-on-hover:hover {
  box-shadow: 0px 3px 0px -1px #cf0000;
}

.p-datatable .p-datatable-tbody>tr:not(.p-highlight)>td #transport-id-hyperLink {
  color: #007bff;
}

.excel-download-button {
  background: darkgreen;
  border: 1px solid darkgreen;
  box-shadow: 0px 1px 8px -1px darkgreen;
  width: 30px;
  height: 30px;
}

.excel-download-button:not(:disabled):hover {
  background: #024602;
  color: #ffffff;
  border-color: #024602;
}

.excel-download-button:focus {
  outline: 0 none;
  outline-offset: 0;
  box-shadow: 0 0 0 0.2rem #48a45a;
}

.excel-upload-button{
  width: 30px;
  height: 30px;
}`, "",{"version":3,"sources":["webpack://./src/assets/General.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,yGAAsG;EACtG,YAAY;AACd;;AAEA;EACE,+BAA+B;EAC/B,iHAA8G;EAC9G,YAAY;AACd;;AAEA;EACE,2DAA2D;EAC3D,oEAAoE;EACpE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mCAAmC;EACnC,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,sDAAsD;EACtD,uBAAuB;AACzB;;AAEA;EACE,iDAAiD;EACjD,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,sDAAsD;EACtD,uBAAuB;AACzB;;AAEA;;;;;GAKG;;AAEH;EACE,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,sCAAsC;EACtC,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["@font-face {\n  font-family: \"T1 Body Font\";\n  src: local(\"T1 Body Font\"), local(\"T1 Body Font\"), url(\"./fonts/toyotadisplay_rg.woff\") format(\"woff\");\n  /* IE6-IE8 */\n}\n\n@font-face {\n  font-family: \"toyotadisplay_bd\";\n  src: local(\"toyotadisplay_bd\"), local(\"toyotadisplay_bd\"), url(\"./fonts/toyotadisplay_bd.woff\") format(\"woff\");\n  /* IE6-IE8 */\n}\n\nbody {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-family: \"T1 Body Font\", Arial, Helvetica, sans-serif !important;\n  font-size: 12px !important;\n}\n\n.loader {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  display: inline-block;\n  border-top: 4px solid #efefef;\n  border-right: 4px solid transparent;\n  box-sizing: border-box;\n  animation: rotation 1s linear infinite;\n}\n\n.loader::after {\n  content: '';\n  box-sizing: border-box;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  border-bottom: 4px solid #cf0000;\n  border-left: 4px solid transparent;\n}\n\n@keyframes rotation {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.button-dark-red-on-hover:hover {\n  color: #a60622 !important;\n}\n\n.p-calendar {\n  position: relative;\n  display: inline-flex;\n  /* max-width: 100%; */\n  width: -webkit-fill-available;\n}\n\ntd:has(> div.arrivedBackground) {\n  background-color: #1c9b1d !important;\n  color: white !important;\n}\n\ntd:has(> div.inboundBackground) {\n  background-color: hsla(36, 69%, 50%, 0.767) !important;\n  color: white !important;\n}\n\ntd:has(> div.pendingBackground) {\n  background-color: hsla(0, 0%, 100%, 0) !important;\n  color: black !important;\n}\n\ntd:has(div.lcpBackground) {\n  background-color: #1c9b1d !important;\n  color: white !important;\n}\n\ntd:has(div.instockBackground) {\n  background-color: hsla(36, 69%, 50%, 0.767) !important;\n  color: white !important;\n}\n\n/* .p-datatable-scrollable>.p-datatable-wrapper {\n  position: relative;\n  overflow: auto;\n  height: 370px;\n  border: 1px solid #dee2e6;\n} */\n\n.p-toast {\n  width: calc(100% - var(--toast-indent, 0px));\n  max-width: 20rem;\n}\n\n#compound-Manager-Table .p-datatable-scrollable>.p-datatable-wrapper {\n  position: relative;\n  overflow: auto;\n  height: 37rem;\n  max-height: 35rem !important;\n  border: 1px solid #dee2e6;\n}\n\n#user-Manager-Table .p-datatable-scrollable>.p-datatable-wrapper {\n  position: relative;\n  overflow: auto;\n  height: 37rem;\n  max-height: 35rem !important;\n  border: 1px solid #dee2e6;\n}\n\n#user-Manager-Table-access .p-datatable-scrollable>.p-datatable-wrapper {\n  position: relative;\n  overflow: auto;\n  height: 10rem;\n  max-height: 10rem !important;\n  border: 1px solid #dee2e6;\n}\n\n#hub-Master-Table .p-datatable-scrollable>.p-datatable-wrapper {\n  position: relative;\n  overflow: auto;\n  height: 37rem;\n  max-height: 35rem !important;\n  border: 1px solid #dee2e6;\n}\n\n.red-line-on-hover:hover {\n  box-shadow: 0px 3px 0px -1px #cf0000;\n}\n\n.p-datatable .p-datatable-tbody>tr:not(.p-highlight)>td #transport-id-hyperLink {\n  color: #007bff;\n}\n\n.excel-download-button {\n  background: darkgreen;\n  border: 1px solid darkgreen;\n  box-shadow: 0px 1px 8px -1px darkgreen;\n  width: 30px;\n  height: 30px;\n}\n\n.excel-download-button:not(:disabled):hover {\n  background: #024602;\n  color: #ffffff;\n  border-color: #024602;\n}\n\n.excel-download-button:focus {\n  outline: 0 none;\n  outline-offset: 0;\n  box-shadow: 0 0 0 0.2rem #48a45a;\n}\n\n.excel-upload-button{\n  width: 30px;\n  height: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
